import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import type { ArbitroWorkspaceState } from '../types';
import type { ModelosEmissaoState } from '../types/modelosEmissaoTypes';
import { listarModelosEmissaoPainel } from './actions';

export const modelosEmissaoInitialState: ModelosEmissaoState = {
  items: [],
  pagination: { page: 0, limit: 20, total: 0, totalPages: 0 },
  processoId: null,
  categoria: null,
  requestId: null,
  loading: false,
  error: null,
};

export function addModelosEmissaoReducers(
  builder: ActionReducerMapBuilder<ArbitroWorkspaceState>,
): void {
  builder
    .addCase(listarModelosEmissaoPainel.pending, (state, action) => {
      const { id, categoria, page = 1 } = action.meta.arg;
      if (page === 1)
        state.modelosEmissao = { ...modelosEmissaoInitialState, processoId: id, categoria };
      const modelos = state.modelosEmissao;
      if (
        modelos.processoId !== id ||
        modelos.categoria !== categoria ||
        page !== modelos.pagination.page + 1
      )
        return;
      modelos.requestId = action.meta.requestId;
      modelos.loading = true;
      modelos.error = null;
    })
    .addCase(listarModelosEmissaoPainel.fulfilled, (state, action) => {
      const modelos = state.modelosEmissao;
      // A montagem pode refazer a primeira busca; uma resposta antiga não deve substituir a atual.
      if (modelos.requestId !== action.meta.requestId) return;
      const existentes = new Set(modelos.items.map((item) => item.templateVersaoId));
      modelos.items.push(
        ...action.payload.items.filter((item) => !existentes.has(item.templateVersaoId)),
      );
      modelos.pagination = action.payload.pagination;
      modelos.loading = false;
      modelos.requestId = null;
    })
    .addCase(listarModelosEmissaoPainel.rejected, (state, action) => {
      const modelos = state.modelosEmissao;
      if (modelos.requestId !== action.meta.requestId) return;
      modelos.loading = false;
      modelos.requestId = null;
      modelos.error = action.payload ?? 'Erro ao carregar modelos';
    });
}
